import ShortCutKey from '../../interaction/shortcutkey/index';
import { StageEvent } from '../../message/index';

function init(): void {
    // 复制
    ShortCutKey.on({
        keyName: 'keyup+r',
        callback: (event) => {
            StageEvent.fire('refreshColorModel', {
                eventFrom: 'stage'
            });
        }
    });
}

export default {
    init
};
